import React from 'react';
import PropTypes from 'prop-types';

import ConditionsBlock from '@organisms/auth/ConditionsBlock';
import { FinclubLogo } from 'IMAGE';

const RegistrationBlockWrapper = ({ containerClass, mainClass, children }) => {
  return (
    <>
      <div className={`registrationBlock ${containerClass || ''}`}>
        <div className={'positionWrapper'}>
          <div className='header'>
            <FinclubLogo />
          </div>
          <div className={`main ${mainClass || ''}`}>{children}</div>
          <div className={'footer'}>
            <ConditionsBlock />
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationBlockWrapper;

RegistrationBlockWrapper.propTypes = {
  userType: PropTypes.string,
  containerClass: PropTypes.string,
  mainClass: PropTypes.string,
  adaptiveLogo: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]).isRequired,
};

RegistrationBlockWrapper.defaultProps = {
  adaptiveLogo: true,
};
